import { useCallback, useEffect, useState } from "react";
import { ADMIN_TOAST_STORAGE_KEY } from "../constants/adminStorageKeys";

type AdminToast = {
  message: string;
  variant: "success" | "error";
};

export function useAdminToast() {
  const [toast, setToast] = useState<AdminToast | null>(null);

  const showSuccessToast = useCallback((message: string) => {
    setToast({ message, variant: "success" });
  }, []);

  const showErrorToast = useCallback((message: string) => {
    setToast({ message, variant: "error" });
  }, []);

  useEffect(() => {
    const raw = sessionStorage.getItem(ADMIN_TOAST_STORAGE_KEY);
    if (!raw) return;
    sessionStorage.removeItem(ADMIN_TOAST_STORAGE_KEY);
    try {
      const parsed = JSON.parse(raw) as { message?: string; variant?: string };
      if (!parsed.message) return;
      if (parsed.variant === "success" || parsed.variant === "error") {
        setToast({ message: parsed.message, variant: parsed.variant });
      }
    } catch (_err) {
      // Ignora payload invalido armazenado no sessionStorage.
    }
  }, []);

  return {
    setToast,
    showErrorToast,
    showSuccessToast,
    toast,
  };
}
